export default __webpack_public_path__ + "static/media/doppelleben_film_image.75840f71.png";